export const transform_datetime_to_string = (datetime) => {
    datetime.setHours(datetime.getHours() + 8); // toISOString是GMT time
    const timestamp_ISO = datetime.toISOString()
    return `${timestamp_ISO.substring(0, 4)}/${timestamp_ISO.substring(5, 7)}/${timestamp_ISO.substring(8, 10)} ${timestamp_ISO.substring(11, 13)}:${timestamp_ISO.substring(14, 16)}`
}

export const transform_datetime_to_HHMM = (datetime) => {
    const {HH, MM} = get_datetime_obj(datetime)
    return `${HH}:${MM}`
}

export const transform_datetime_str_to_chart_need_format = (datetime_str) => { 
    const ISO_datetime_str = convert_ISO_datetime_str(datetime_str)
    const {yyyy, mm, dd, HH, MM} = get_datetime_obj(new Date(ISO_datetime_str))
    return `${yyyy}-${mm}-${dd} ${HH}:${MM}`
}

export const convert_ISO_datetime_str = (datetime_str) => {
    return _is_common_datetime_str(datetime_str) ? _replace_common_datetime_str_to_ISO_str(datetime_str) : datetime_str
}

export const transform_timestamp_to_customized_str = (timestamp, callback) => {
    return callback(get_datetime_obj(new Date(timestamp)))
}

const _is_common_datetime_str = (datetime_str) => {
    const COMMON_DATETIME_REGULAR_EXPRESSION = new RegExp('(\\d{4})-(\\d{2})-(\\d{2}) (\\d{2}):(\\d{2}):(\\d{2})')
    return COMMON_DATETIME_REGULAR_EXPRESSION.test(datetime_str)
}

const _replace_common_datetime_str_to_ISO_str = (datetime_str) => {
    return datetime_str.replace(' ', 'T')
}

export const get_datetime_obj = (d) => {
    return {
        yyyy: d.getFullYear(),
        mm: format_add_zero(d.getMonth() + 1),
        dd: format_add_zero(d.getDate()),
        HH: format_add_zero(d.getHours()),
        MM: format_add_zero(d.getMinutes()),
    }
}

const format_add_zero = (data) => {
    let str = String(data)
    return str.length < 2 ? `0${str}` : str
}